import config, { Config } from 'config/config';
import { initialNotificationState } from './entities/notification/slice';
import { initialMarketState } from './entities/market/slice';
import { initialOrderbookState } from './entities/market/orderbook/slice';
import { initialweb3ConfigState } from './entities/web3Config';
import { initialTradeState } from './entities/trade/helpers';
import { initialWalletState } from './entities/wallet/slice';

import { 
  MarketStateT,
  OrderbookStateT,
  NotificationStateT,
  WalletStateT,
  TradeStateT,
  Web3ConfigStateT,
} from 'types';


export interface Store {
  config: Config;
  web3Config: Web3ConfigStateT; // maybe put to global state.config state
  notifications: NotificationStateT;
  market: MarketStateT;
  orderbook: OrderbookStateT;
  wallet: WalletStateT;
  trade: TradeStateT;
}

const state: Store = {
  config,
  web3Config: initialweb3ConfigState,
  notifications: initialNotificationState,
  market: initialMarketState,
  orderbook: initialOrderbookState,
  wallet: initialWalletState,
  trade: initialTradeState,
};

export default state;
